"use client";

import { addNextjsError } from "@datadog/browser-rum-nextjs";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    addNextjsError(error);
  }, [error]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <Card className="max-w-md p-6 text-center">
        <p className="font-medium text-muted-foreground text-xs">Application error</p>
        <h1 className="mt-3 font-heading text-2xl text-foreground">Something went wrong</h1>
        <p className="mt-3 text-muted-foreground text-sm leading-6">
          You can retry the page now, or come back after the current operation has been checked.
        </p>
        <Button className="mt-6" onClick={reset} type="button">
          Try again
        </Button>
      </Card>
    </main>
  );
}
